import React from "react";

export const FeatureItem = ({ text, icon = "+"}) => {
    return (
        <div className="feature-item d-flex align-items-center py-2 px-3 mb-2 border rounded">
            <span className="feature-icon fw-bold me-2 premium-green">{icon}</span>
            <span className="feature-text">{text}</span>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/c/FeatureItem.js